import { render, staticRenderFns } from "./Tappable.vue?vue&type=template&id=1fa7acc5&"
import script from "./Tappable.vue?vue&type=script&lang=js&"
export * from "./Tappable.vue?vue&type=script&lang=js&"
import style0 from "./Tappable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports